import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#050814] py-12 px-5 sm:px-8 lg:px-12 text-center border-t border-white/5" data-id="element-16">
      <div className="max-w-6xl mx-auto" data-id="element-17">
        <p className="text-gray-500 text-xs mb-4" data-id="element-18">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-19">
          La información contenida en este sitio web se proporciona únicamente
          con fines informativos y educativos. No pretende sustituir el consejo,
          diagnóstico o tratamiento médico profesional. Siempre busque el
          consejo de su médico u otro proveedor de salud calificado con
          cualquier pregunta que pueda tener sobre una condición médica.
        </p>

        <div className="flex justify-center gap-6 text-gray-400 text-sm mb-6" data-id="element-20">
          <a href="#" className="hover:text-white transition-colors" data-id="element-21">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-22">
            Políticas de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-23">
            Contacto
          </a>
        </div>

        <p className="text-gray-600 text-sm" data-id="element-24">
          © {new Date().getFullYear()} Ecompra Digital. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}